import React from "react";

function BrandMark({ variant = "light" }) {
  const isDark = variant === "dark";

  return (
    <div
      className={`relative flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-gradient-to-br from-emerald-400 via-emerald-600 to-teal-700 shadow-lg transition-all duration-300 group-hover:scale-105 group-hover:shadow-xl ${
        isDark
          ? "shadow-emerald-900/40 ring-2 ring-emerald-400/25 group-hover:ring-emerald-300/40"
          : "shadow-emerald-600/35 ring-2 ring-emerald-500/20 group-hover:ring-emerald-400/35"
      }`}
      aria-hidden="true"
    >
      <div className="absolute inset-0 rounded-xl bg-gradient-to-t from-black/10 to-white/20" />
      <span className="relative text-sm font-black tracking-[0.14em] text-white drop-shadow-md">
        YRB
      </span>
    </div>
  );
}

export default BrandMark;
